import React, {useCallback} from 'react';


import {BulkActionResultModal} from 'src/components/bulk-tool';
import {CompleteMark} from 'src/components/complete-mark';
import {UserLink} from 'src/components/links';
import {RowNumbered} from 'src/components/row-numbered';
import {getSendWelcomeEmailsProgress, getSendingResult} from 'src/openapi/admin/apis/BulkSendWelcomeEmailsApi';
import {useAppDispatch} from 'src/store/hooks';

import {Body, Cell, Head, Row, Table} from '@pb/kit-component-table';

import {FILE_HEADERS, FILE_NAME, TOOL_TITLE} from './constants';
import {ResultModalDescription} from './result-modal-description';

import type {Pagination} from 'src/openapi/admin/models/Pagination';
import type {ProcessedEmailItem} from 'src/openapi/admin/models/ProcessedEmailItem';

type Props = {
    id: string,
    onClose: () => void,
};

const PLACE = `Bulk ${TOOL_TITLE} Result`;

export const SendWelcomeEmailResultModal = ({id, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    const getPaginatedResults = useCallback(
        (bulkResult: ProcessedEmailItem[], {currentPage, pageSize}: Pagination) => bulkResult
            .slice((currentPage - 1) * pageSize, currentPage * pageSize)
            .map((res: ProcessedEmailItem, index) => (
                <Row key={index}>
                    <Cell width={50}>
                        <RowNumbered
                            maxRowNumber={bulkResult?.length || 0}
                            placeholder={(currentPage - 1) * pageSize + index + 1}
                        />
                    </Cell>
                    <Cell>
                        <UserLink userId={res.userId || 0} caption={res.email} blank={true} place={PLACE}/>
                    </Cell>
                    <Cell>
                        <CompleteMark errors={res.errors}/>
                    </Cell>
                </Row>
            )),
        [],
    );

    return (
        <BulkActionResultModal<ProcessedEmailItem>
            id={id}
            onClose={onClose}

            toolTitle={TOOL_TITLE}
            description={bulkResult => (
                <ResultModalDescription
                    toolTitle={TOOL_TITLE}
                    fileName={FILE_NAME}
                    fileHeaders={FILE_HEADERS}
                    bulkResult={bulkResult}
                />
            )}
            table={(bulkResult, pagination) => (
                <Table borderedGrid={true}>
                    <Head>
                        <Cell width={50}><strong>#</strong></Cell>
                        <Cell>User Email</Cell>
                        <Cell width={150}>Action Status</Cell>
                    </Head>
                    <Body>
                        {getPaginatedResults(bulkResult, pagination)}
                    </Body>
                </Table>
            )}

            getProgress={() => apiDispatch(getSendWelcomeEmailsProgress({id}))}
            getResult={() => apiDispatch(getSendingResult({id}))}

            sortComparator={(a, b) => a.email.localeCompare(b.email)}
        />
    );
};
